module.exports = __webpack_public_path__ + "img/艺术发展研究中心.9ecb2937.jpg";